// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ka-0";
export var assigneeDetails = "_ka-1";
export var assigneeInfo = "_ka-2";
export var dropdownContainer = "_ka-4";
export var dropdownImage = "_ka-5";
export var editAssigneeInfo = "_ka-3";
export var editAssigneeModalContainer = "_ka-6";
export var hidden = "_ka-8";
export var input = "_ka-7";